export default "__VITE_ASSET__7zVLRSk3__"